import React, { useState } from 'react';
import { AlertOctagon } from 'lucide-react';
import { api } from '@/lib/api';

export default function KillSwitchButton({ onKill }) {
  const [open, setOpen] = useState(false);
  const [ack, setAck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const doKill = async () => {
    if (!ack) return;
    setLoading(true); setError(null);
    try {
      const { data } = await api.post('/positions/kill-all');
      setOpen(false); setAck(false);
      if (onKill) onKill(data);
    } catch (e) {
      setError(e?.response?.data?.detail || 'Falló el kill switch');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        data-testid="btn-open-kill-switch"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-xs font-medium border border-red-500/40 bg-red-500/10 text-red-400 hover:bg-red-500/20 transition-colors"
      >
        <AlertOctagon size={14} />
        Kill switch
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true">
          <div className="panel w-full max-w-md p-5" data-testid="kill-switch-modal">
            <div className="flex items-start gap-3 mb-3">
              <div className="p-2 rounded-md bg-red-500/10 text-red-400">
                <AlertOctagon size={18} />
              </div>
              <div>
                <h3 className="text-base">Cerrar todas las posiciones</h3>
                <p className="text-sm text-muted-foreground mt-1">
                  Esta acción es irreversible: cerrará todas las posiciones abiertas al precio actual simulado y activará el kill switch del día (no se admitirán nuevas aprobaciones).
                </p>
              </div>
            </div>
            <label className="flex items-start gap-2 py-2 cursor-pointer">
              <input
                data-testid="kill-ack"
                type="checkbox"
                className="mt-1"
                checked={ack}
                onChange={(e) => setAck(e.target.checked)}
              />
              <span className="text-sm">Entiendo que se cerrarán todas las posiciones y se activará el kill switch diario.</span>
            </label>
            {error && <div className="text-sm text-destructive mt-2">{error}</div>}
            <div className="flex items-center justify-end gap-2 mt-4">
              <button
                data-testid="btn-kill-cancel"
                className="px-3 py-1.5 rounded-md text-sm border border-border hover:bg-muted"
                onClick={() => { setOpen(false); setAck(false); setError(null); }}
                disabled={loading}
              >Cancelar</button>
              <button
                data-testid="btn-kill-confirm"
                disabled={!ack || loading}
                onClick={doKill}
                className={`px-3 py-1.5 rounded-md text-sm text-white ${ack ? 'bg-red-600 hover:bg-red-700' : 'bg-red-600/40 cursor-not-allowed'}`}
              >{loading ? 'Cerrando...' : 'Confirmar cierre total'}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
